
import Vue from 'vue'
import ShareMaskComponent from './ActivityShareMask.vue'

let shareMaskInstance
const ShareMaskConstructor = Vue.extend(ShareMaskComponent) // 使用extend方法创建类似Vue的构造函数
const shareMask = function(options = {}) {
  shareMaskInstance = new ShareMaskConstructor({
    data: options
  })
  document.body.appendChild(shareMaskInstance.$mount().$el)
}

export default shareMask
